import { useQuery } from "@tanstack/react-query";
import { socialApi } from "@bw/shared/api";
import type { FriendSummaryResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The caller's accepted-friends list (GET /social/friends), returned VERBATIM as
 * enriched FriendSummaryResponse objects ({user_id, display_name, avatar_url}) —
 * never a bare uid string. The server scopes the list to the token user, so the
 * cache key carries no uid. Rendered by display_name (never the raw user_id).
 *
 * Cached under the `social.friends` key; an unfriend mutation (or an accepted
 * friend request) invalidates it to refetch the server's truth — see
 * useFriendActions. No client sort, no derived state.
 */
export function useFriends() {
  return useQuery<FriendSummaryResponse[]>({
    queryKey: queryKeys.social.friends(),
    queryFn: () => socialApi.getFriends(),
  });
}
